import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type ProfileListState = {
  selected?: {
    id: string;
    index: number;
  };
};

const initialState: ProfileListState = {};

export const profileListSlice = createSlice({
  name: "profileList",
  initialState,
  reducers: {
    setSelectedProfile: (
      state,
      { payload }: PayloadAction<ProfileListState["selected"]>
    ) => {
      state.selected = payload;
    },
    setSelectedProfileById: (state, { payload }: PayloadAction<string>) => {
      state.selected = { id: payload, index: 0 };
    },
    resetSelectedProfile: (state) => {
      state.selected = undefined;
    },
    resetProfileList: () => initialState,
  },
});

export const {
  resetProfileList,
  setSelectedProfile,
  setSelectedProfileById,
  resetSelectedProfile,
} = profileListSlice.actions;

export default profileListSlice.reducer;
